(ns arthur.ui.undo
  "Undo, redo, and the list of what undo would take off — newest first, so
  choosing the third row undoes three steps."
  (:require [arthur.events.history :as history]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn view []
  (r/with-let [open? (r/atom false)]
    (let [{:keys [done undone]} @(rf/subscribe [::history/steps])]
      [:div.menu-wrap.undo
       [:button {:disabled (empty? done) :title (if (seq done) (str "undo " (first done) " (⌘Z)") "nothing to undo")
                 :on-click #(rf/dispatch [::history/undo])}
        "undo"]
       [:button.undo-list {:disabled (empty? done) :class (when @open? "on")
                           :title "undo history" :on-click #(swap! open? not)}
        "▾"]
       [:button {:disabled (empty? undone) :title (if (seq undone) (str "redo " (first undone) " (⇧⌘Z)") "nothing to redo")
                 :on-click #(rf/dispatch [::history/redo])}
        "redo"]
       (when (and @open? (seq done))
         [:<> [:div.menu-scrim {:on-click #(reset! open? false)}]
          [:div.menu.menu-left
           [:h2 "undo"]
           (doall
            (map-indexed
             (fn [i label]
               ^{:key i}
               [:button.menu-item {:on-click (fn [] (reset! open? false)
                                               (rf/dispatch [::history/undo (inc i)]))}
                label (when (pos? i) [:span.sub (str (inc i) " steps")])])
             (take 30 done)))]])])))
